var templates = require('../../ui/templates/article-keypoints.template');
var parser    = require('../../ui/formatters/key-points-parser');
var shared    = require('../../modules/shared');
var tracker   = require('./keypoints-viewport-tracker');
var v2Answer  = require('./v2-answer-modal');
var _vars     = require('../../modules/vars')._vars;

function renderKeyPoints(bullets, wrapper) {
    if (!bullets || bullets.length === 0 || !wrapper) {
        return false;
    }

    var artGuid = '';
        
    if(Number(PageMetadata.pageSegVars.cmsid) == 2) {
        artGuid = PageMetadata.pageSegVars.asst;
    } else {
        artGuid = PageMetadata.pageSegVars.art.replace(/\D/g, '');
    }

    var skeletonBody   = wrapper.querySelector('.skeleton-body');
    var skeletonHeader = wrapper.querySelector('.skeleton-header');
    if (skeletonBody)   { skeletonBody.remove(); }
    if (skeletonHeader) { skeletonHeader.remove(); }

    var newsSpecific = document.querySelector('#ai-wrapper-key-points-' + artGuid) !== null;
    var keyPointTitle = newsSpecific ? 'Article Key Points' :  'Key Points';
    wrapper.insertAdjacentHTML('afterbegin', templates.articleInlineKeyPointsCard(bullets, keyPointTitle));
    if(window && window.mscpA2A) {
        tracker.init({ selector: '#ai-wrapper-key-points-'+ artGuid +' #key-points-card' });
    } else {
         tracker.init({ selector: '#key-points-card' });
    }   
    return true;
}

// Same tracking in both A/B tracks; Track B (window.useV2AI / ?isv2ai) sends the query to the V2 answer page.
function onFollowUpActivate(item) {
    // Use the visible chip text as the query (data-question is interpolated unescaped, so the
    // text node is the safer source). Falls back to the attribute if the span is missing.
    var textEl = item.querySelector('.inline-follow-up-text');
    var question = (textEl ? textEl.textContent : item.getAttribute('data-question') || '').trim();
    var index = item.getAttribute('data-index');
    if (typeof wmdTrack === 'function') {
        wmdTrack('ai-search_initial-prompt-' + parseInt(index));
    }
    aiSchPageview(0);
    if (!question) { return; }
    if (v2Answer.isV2AIEnabled()) {
        v2Answer.openV2Answer(question, item);
    } else {
        shared.handleSearch(question);
    }
}

function renderFollowUps(questions, wrapper) {
    if (!wrapper) {
        return false;
    }

    var unique = parser.deduplicateQuestions(questions, 3);
    var links = (_vars.cfg && _vars.cfg.deepDiveLinks) || [];
    // Deep Dive pills are a News-product-type-specific feature. The wrapper
    // carries a data-product-type attribute set by
    // professional-article-maincontent's keyPointsMixin (computed fresh per
    // article, so it's correct for A2A too). Other product types that render
    // Key Points via the same mixin (e.g. EED) get a non-"news" value, and
    // other products entirely (e.g. Condition/eMedicine pages, which inject
    // their own generic wrapper) never set this attribute at all - both cases
    // correctly fall through to no pills. The "Dive Deeper" label and AI
    // follow-up questions still show everywhere - only the static pills are
    // gated.
    var isNewsArticle = wrapper.getAttribute('data-product-type') === 'news';
    var showPills = isNewsArticle && links.length > 0;


    // Always clear the footer skeleton so it never lingers, even when there's nothing to render.
    var skeletonFooter = wrapper.querySelector('.skeleton-footer');
    if (skeletonFooter) { skeletonFooter.remove(); }

    // Nothing to show — no AI follow-ups and no pills (pills only render in the combined module).
    if (unique.length === 0 && !showPills) {
        return false;
    }

    // "Dive Deeper" section: separator + label, then the AI follow-up prompts (if any), then the
    // static Deep Dive pills. Rendered as sibling children of the wrapper so the wrapper's flex
    // `gap` spaces them evenly. Show separator and label only shown for news article pages.
    var diveDeeperHtml =
        (isNewsArticle ? '<div class="key-points-divider" role="separator"></div>' +
        '<div class="dive-deeper-label">Dive Deeper</div>' : '') +
        (unique.length ? templates.articleInlineFollowUpQuestionsTemplate(unique) : '') +
        (showPills ? templates.articleInlineDeepDivePillsTemplate(links) : '');
    wrapper.insertAdjacentHTML('beforeend', diveDeeperHtml);

    // Wire event handlers on the newly inserted chips
    wrapper.querySelectorAll('.inline-follow-up-item').forEach(function(item) {
        item.addEventListener('click', function() {
            onFollowUpActivate(this);
        });

        item.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onFollowUpActivate(this);
            }
        });
    });

    // Report whether AI follow-up prompts were rendered (pills are static and don't count),
    // preserving the existing kpt/flwups analytics semantics.
    return unique.length > 0;
}

// PROFCORE-34854: appends the rating widget as the wrapper's last element. Idempotent.
function renderRating(wrapper) {
    if (!wrapper || wrapper.querySelector('.key-points-rating')) {
        return false;
    }

    if (!document.getElementById('keyPointsFeedbackDrawer')) {
        document.body.insertAdjacentHTML('beforeend', templates.keyPointsFeedbackDrawerTemplate());
    }

    wrapper.insertAdjacentHTML('beforeend', templates.keyPointsRatingTemplate());
    return true;
}

module.exports = {
    renderKeyPoints:  renderKeyPoints,
    renderFollowUps:  renderFollowUps,
    renderRating:     renderRating
};
